<template>
  <div id="app">
    <header>
      <div id="nav">
        <b-navbar toggleable="lg" type="light" variant="mdh">
          <b-navbar-brand>
            <img src="./assets/logo-reverse.png" style="height:38px;" alt="Minnesota Department of Health Logo"/>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item href="/home">Home</b-nav-item>
              <b-nav-item href="/request" v-if="hasAnyRole()">Create New Request</b-nav-item>

              <b-nav-item-dropdown id="reports_admin" text="Reports" v-if="hasAnyRole()">
                <b-dropdown-item href="/search">Search</b-dropdown-item>
                <b-dropdown-item href="/workprogressmonitor">Work Progress Monitor</b-dropdown-item>
                <b-dropdown-item href="/activePayrollRequests" v-if="authenticated &&  (isPayroll() || isAdmin())">Active Payroll Requests</b-dropdown-item>
                <b-dropdown-item href="/completedPayrollRequests" v-if="authenticated &&  (isPayroll() || isAdmin())">Completed Payroll Requests</b-dropdown-item>
                <b-dropdown-item href="/salary" v-if="authenticated && (isSpecialist() || isAdmin())">Salary Recommendation Report</b-dropdown-item>
                <b-dropdown-item href="/tracking-search" v-if="authenticated && isAdmin()">Admin Tracking ID Search</b-dropdown-item>
              </b-nav-item-dropdown>

              <b-nav-item-dropdown id="reports_leave" text="Leave Reports" v-if="authenticated && (isLeave() || isAdmin())">
                  <b-dropdown-item href="/newLeaveRequests" >New Leave Requests</b-dropdown-item>
                  <b-dropdown-item href="/approvedLeaveRequests">Approved Leave Requests</b-dropdown-item>
                  <b-dropdown-item href="/closedLeaveRequests">Closed Leave Requests</b-dropdown-item>
                  <b-dropdown-item href="/leaveSearch">Leave Request Search</b-dropdown-item>
              </b-nav-item-dropdown>

              <b-nav-item href="/dashboard" v-if="hasAnyRole()">Dashboard</b-nav-item>

              <b-nav-item-dropdown id="menu_admin" text="Admin"
                   v-if="authenticated && (isAdmin() || isCwd() || isLead())">
                  <b-dropdown-item href="/bureau" v-if="authenticated && isAdmin()">Manage Bureaus</b-dropdown-item>
                  <b-dropdown-item href="/specialist" v-if="authenticated && isAdmin()">Manage Specialists</b-dropdown-item>
                  <b-dropdown-item href="/division" v-if="authenticated && isAdmin()">Manage Divisions</b-dropdown-item>

                  <b-dropdown-item href="/requesttype" v-if="authenticated && isAdmin()">Manage Request Types</b-dropdown-item>
                  <b-dropdown-item href="/managestatus" v-if="authenticated && isAdmin()">Manage Request Statuses</b-dropdown-item>
                  <b-dropdown-item href="/assignment/staffing" v-if="authenticated && (isAdmin() || isLead())">Manage Staffing Assignments</b-dropdown-item>
                  <b-dropdown-item href="/assignment/payroll" v-if="authenticated && isAdmin()">Manage Payroll Assignments</b-dropdown-item>

                  <b-dropdown-item href="/requeststatus" v-if="authenticated && (isAdmin() || isLead())">Change Request Status</b-dropdown-item>
                  <b-dropdown-item href="/checklist" v-if="authenticated && isAdmin()">Manage Check Lists</b-dropdown-item>
                  <b-dropdown-item href="/settings" v-if="authenticated && (isAdmin() || isCwd())" >Manage Application Settings</b-dropdown-item>
                  <b-dropdown-item href="/approvers" v-if="authenticated && isAdmin()">Manage Request Approvers</b-dropdown-item>
                  <b-dropdown-item href="/attachments" v-if="authenticated && isAdmin()">Manage Attachments</b-dropdown-item>
                  <b-dropdown-item href="/reports" v-if="authenticated && isAdmin()">HRM Reports</b-dropdown-item>
                  <b-dropdown-item href="/standardcomment" v-if="authenticated && isAdmin()">Manage Standard Leave Comments</b-dropdown-item>
              </b-nav-item-dropdown>

              <b-nav-item-dropdown id="menu_admin" text="User Management"
                                   v-if="authenticated && isUserAdmin()">
                  <b-dropdown-item href="/requestRoleSearch">Manage Role Requests</b-dropdown-item>
                  <b-dropdown-item href="/userSearch">Manage Users</b-dropdown-item>
              </b-nav-item-dropdown>

              <b-nav-item href="/requestRole" v-if="authenticated">Request Role</b-nav-item>

              <b-nav-item @click="logout" v-if="authenticated">Log out <span style="font-size:.9em">({{username}})</span></b-nav-item>
              <b-nav-item @click="login" v-if="!authenticated">Log in</b-nav-item>

            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </header>

    <main id="main-content">
      <b-container fluid>
              <router-view/>
      </b-container>
    </main>

<div class="mt-5">
  <footer>
    <hr class="mt-2"/>
    <div class="fluid-container footer">
      <p class="text-center">For questions, please email <a :href="`mailto:${contactEmail}`">{{contactEmail}}</a>  - v{{appVersion}}</p>
    </div>
  </footer>
</div>

  </div>
</template>

<script>
  import LocalStorageService from '@/common/LocalStorageService';
  import {version} from '../package.json';
  import { CONTACT_EMAIL_ADDRESS } from '@/constants'
  import SecureLS from "secure-ls";
  import { roleService } from "@/mixins/roleService.js";

  export default {
    mixins: [
        roleService
    ],
    computed: {
      authenticated: function() {
        if (this.$keycloak) {
          return this.$keycloak.authenticated;
        } else {
          return false;
        }
      },
      username: function() {
        return this.$keycloak.userName
      },
      appVersion: function() {
        return version;
      },
      contactEmail: function() {
        return CONTACT_EMAIL_ADDRESS
      },
    },

    methods: {
      login () {
        const localStorageService = LocalStorageService.getService();
        localStorageService.clearAuthTokens();    
        const loginUrl = this.$keycloak.createLoginUrl()
        window.location.replace(loginUrl)  
      },
      logout() {
        const localStorageService = LocalStorageService.getService()
        localStorageService.clearAuthTokens()
        this.$store.dispatch('resetState')

        let ls = new SecureLS({ isCompression: false });
        ls.set('hrm-request-search-criteria', null)
        ls.set('hrm-request-search-results', null)

        this.$keycloak.clearToken()
        this.$keycloak.logoutFn()
      },
    },
    created() {
    },
  }
</script>

<style lang="scss">

  @import "assets/_custom.scss";
  @import "mdh-vue-select/src/scss/vue-select.scss";
  @import "~bootstrap/scss/bootstrap.scss";
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
#app {
  font-family: 'Roboto', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

h1 {
  font-size: 30px;
  font-weight: 600;
}

h2 {
  font-size: 24px;
  font-weight: 600;
}

button {
  margin-right: 18px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.bg-mdh {
  background-color: rgb(0, 56, 101);
}

#nav {
  padding-bottom: 30px;
}

#nav a {
  font-weight: normal;
  color: white;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#nav  a.dropdown-item {
  color: black !important;
}

.navbar-toggler-icon {
   background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='rgba(255, 255, 255, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>") !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

.colWidth40 {
  width: 40%;
}

.is-invalid .d-block {
    color: #dc3545;
}

.label-required::after {
  color: #528217 ;
  font-size: .7em;
  text-transform: uppercase;
  margin-left: 19px;
  content:" required";
}

</style>
